import { cn } from "../../utils/cn";
import { Icon } from "@iconify/react";
import { Button } from "../base";

export const PricingCard = ({
    tenure = "monthly",
    name,
    description,
    value,
    unit,
    currency = "$",
    features,
    button,
    className,
    onMulaiSekarang,
}) => {
    return (
        <div
            className={cn(
                "flex flex-col justify-start items-start px-5 pt-5 pb-5 rounded-2xl border w-[270px] overflow-hidden",
                "transition-all duration-300 ease-out",
                "hover:-translate-y-2 hover:shadow-xl",
                className,
            )}
            style={{
                background:
                    "linear-gradient(to right, rgba(219, 245, 255, 0.2), rgba(80, 222, 255, 0.2))",
                borderColor: "#DBF5FF",
            }}
        >
            <h5 className="text-title font-medium text-base">{name}</h5>
            {description && <p>{description}</p>}
            <div className="flex flex-col gap-1 mt-6">
                {value[tenure] === 0 ? (
                    <div className="inline-flex items-baseline gap-2">
                        <h2 className="text-5xl font-semibold leading-none text-title">
                            Gratis
                        </h2>
                        <span className="text-sm text-muted">{unit}</span>
                    </div>
                ) : (
                    <div className="inline-flex gap-1 items-baseline flex-nowrap">
                        <span className="text-lg text-muted">{currency}</span>
                        <h2 className="text-5xl font-semibold leading-none text-title">
                            {(() => {
                                const formattedValue =
                                    typeof value[tenure] === "number"
                                        ? value[tenure].toLocaleString("id-ID")
                                        : value[tenure].toString();
                                const parts = formattedValue.split(".");
                                if (parts.length > 1) {
                                    return (
                                        <>
                                            <span>{parts[0]}</span>
                                            <span style={{ fontSize: "22px" }}>
                                                .{parts[1]}
                                            </span>
                                        </>
                                    );
                                }
                                return formattedValue;
                            })()}
                        </h2>
                        <span className="text-xs text-muted whitespace-nowrap">
                            {unit}
                        </span>
                    </div>
                )}
            </div>
            <ul className="flex flex-col gap-2 mt-6 overflow-y-auto w-full pr-1">
                {features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2">
                        <Icon
                            icon="tabler:check"
                            className="size-5"
                            style={{ color: "#06B6D4" }}
                        />{" "}
                        <span className="text-sm text-body">{feature}</span>
                    </li>
                ))}
            </ul>
            <div className="w-full mt-6">
                <Button block {...button} onClick={onMulaiSekarang} />
            </div>
        </div>
    );
};